goog.provide('el8.appchart.medsHx.displaySummary');

goog.require('el8.service.urls');

el8.appchart.medsHx.displaySummary = function() {
    var $elt = $('#download-fills-last-update-menu-item');

    $.el8_ajax({
        type: 'POST',
        url: el8.service.urls.get('lastRxHistoryDownloadDate'),
        success: function(data) {
            if (data['latest_date']) {
                var latestDate = el8.service.tz.toTzDateTime(data['latest_date']);
                $elt.show();
                $elt.text('Last Update: ' + latestDate.asDateTimeString());
            } else {
                $elt.empty();
                $elt.hide();
            }
        }
    });

};
